/**
 * Detect if the app is running in a web browser (vs a native app wrapper).
 * Returns true for normal browser; false for Capacitor, Cordova, PhoneGap, or React Native WebView.
 * @returns {boolean}
 */
export function isWebBrowser() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return true;
  }
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileApp =
    userAgent.includes('capacitor') ||
    userAgent.includes('cordova') ||
    userAgent.includes('phonegap') ||
    typeof window.Capacitor !== 'undefined' ||
    typeof window.cordova !== 'undefined';
  const isReactNative =
    userAgent.includes('reactnative') || typeof window.ReactNativeWebView !== 'undefined';
  return !isMobileApp && !isReactNative;
}
